import React, { useState, useEffect } from "react";
import axios from "axios";
import { Container, Row, Col, Card, Spinner, Alert } from "react-bootstrap";
import Notification from "../../../components/common/notification/Notification";
import { Link, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import SingleDetailHeader from "../../components/singleDetail/SingleDetailHeader";
import BreadCrumb from "../../components/breadcrumb/BreadCrumb";
import {
  QuestionCircleFill,
  Clock,
  PersonLinesFill,
  PersonFill,
  EnvelopeFill,
  TelephoneFill,
  ChatLeftTextFill,
} from 'react-bootstrap-icons';

const HelpCenterItem = () => {
  const loggedInUser = useSelector((state) => state.auth.user);
  const { Id } = useParams();
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const token = loggedInUser?.refreshToken;

  const [contactUs, setContactUs] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  const breadcrumbItems = [
    { label: '', link: '/', icon: 'fa-solid fa-house' },
    { label: 'Help Center', link: '/help-center' },
    { label: Id, link: '', active: true },
  ];

  useEffect(() => {
    fetchHelpCenterItem();
  }, []);

  const fetchHelpCenterItem = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${baseUrl}/admin/contactus/${Id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        setContactUs(response.data.contactUs);
      }
    } catch (error) {
      console.error(error);
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const [date, time] = dateString.split(" ");
    return `${date} at ${time}`;
  };
  
  return (
    <>
      <Notification />
      <Container>
        <BreadCrumb items={breadcrumbItems} />
        
        <Row>
          <Col lg={9} md={8} sm={12}>
            <SingleDetailHeader
              header="Help Center Item"
              description="Inquiry details"
            />
          </Col>
        </Row> 

        <Row className="my-3 justify-content-center"> 

          <Col lg={9} md={8} sm={12}>
            {(() => {
              if (isLoading) {
                return <Spinner animation="border" />;
              }
              if (isError) {
                return <Alert variant="danger">Error fetching data</Alert>;
              }
              if (contactUs) {
                return (
                  <Card className="border rounded-4 shadow-sm">
                    <Card.Body className="p-4">
                      {/* Header */}
                      <div className="d-flex align-items-center mb-3">
                        <QuestionCircleFill className="text-primary me-3 fs-5" /> {/* Inquiry Icon */}
                        <h5 className="mb-0 text-dark fw-bold">Inquiry Details</h5>
                        <span className={`badge rounded-pill ms-auto ${contactUs.active ? 'bg-success' : 'bg-secondary'}`}>
                          {contactUs.active ? 'Active' : 'Inactive'}
                        </span>
                      </div>

                      <p className="text-muted mb-3 small">
                        <Clock className="me-2" /> Received on: {formatDate(contactUs.created_on)}
                      </p>
                      <hr className="my-2" />

                      {/* Contact Information */}
                      <div className="mb-3">
                        <p className="mb-1">
                          <PersonFill className="text-secondary me-2" />
                          <span className="fw-semibold text-dark">Name:</span>
                          <span className="ms-2 text-secondary">{contactUs.name}</span>
                        </p>
                        <p className="mb-1">
                          <EnvelopeFill className="text-info me-2" />
                          <span className="fw-semibold text-dark">Email:</span>
                          <span className="ms-2 text-secondary">{contactUs.email_address}</span>
                        </p>
                        {contactUs.mobile_number && (
                          <p className="mb-0">
                            <TelephoneFill className="text-success me-2" />
                            <span className="fw-semibold text-dark">Phone:</span>
                            <span className="ms-2 text-secondary">{contactUs.mobile_number}</span>
                          </p>
                        )}
                      </div>

                      {/* Message */}
                      <div>
                        <h6 className="text-muted fw-semibold small mb-2">
                          <ChatLeftTextFill className="me-2" /> Message
                        </h6>
                        <div className="bg-light border rounded p-3 small text-dark">
                          <p className="mb-0 text-break">{contactUs.message}</p>
                        </div>
                      </div>
                    </Card.Body>
                  </Card> 
                );
              }
              return <Alert variant="warning">No data available</Alert>;
            })()}

            <Link
              className="btn btn-primary my-4"
              to={"/help-center"}
            >
              Back
            </Link>
          </Col>

        </Row>
        
      </Container>
      


    </>
  );
};

export default HelpCenterItem;
